import './style.css';

let defaultPopupParams = {
    closeByEsc: true,
    closeByBackground: true,
    animated: true,
    popupClass: 'devbx-popup',
    popupBackground: 'devbx-popup-background',
    popupContent: 'devbx-popup-content',
    events: {},
};

let popupInstance = [];

class PopupManager {

    static getShowed()
    {
        let result = [];

        popupInstance.forEach(instance => {
            if (instance.showed)
                result.push(instance);
        });

        return result;
    }

}

class Popup {

    constructor(params) {
        this.params = Object.assign({}, defaultPopupParams, params || {});

        this.elPopup = document.createElement('DIV');
        this.elBackground = document.createElement('DIV');
        this.elContent = document.createElement('DIV');

        this.elPopup.className = this.params.popupClass;
        this.elBackground.className = this.params.popupBackground;
        this.elContent.className = this.params.popupContent;

        this.elPopup.append(this.elBackground, this.elContent);

        this.domEvents = [];

        this.showed = false;

        popupInstance.push(this);
    }

    destroy()
    {
        if (this.destroyed || this.destroyInProcess)
            return;

        this.destroyInProcess = true;

        if (this.params.animated)
        {
            this.addEvent(this.elPopup, 'transitioncancel', (event) => {
                if (event.target === this.elPopup)
                    this.$destroy();
            });

            this.addEvent(this.elPopup, 'transitionend', (event) => {
                if (event.target === this.elPopup)
                    this.$destroy();
            });

            this.elPopup.classList.add('devbx-popup-closing');
            this.elPopup.classList.add('devbx-popup-animated');
        } else {
            this.$destroy();
        }
    }

    $destroy()
    {
        if (this.destroyed)
            return;

        if (typeof this.params.events.onDestroy ==='function') {
            this.params.events.onDestroy();
        }

        this.domEvents.forEach(ar => {
            ar[0].removeEventListener(ar[1], ar[2]);
        });
        this.domEvents = [];

        this.elBackground.remove();
        this.elContent.remove();
        this.elPopup.remove();

        this.elBackground = false;
        this.elContent = false;
        this.elPopup = false;

        let idx = popupInstance.indexOf(this);
        if (idx>=0)
            popupInstance.splice(idx,1);

        if (!PopupManager.getShowed().length)
        {
            document.documentElement.classList.remove('with-devbx-popup');
            document.body.classList.remove('devbx-hide-scrollbar');
            document.documentElement.style.removeProperty('--devbx-scrollbar-compensate');
        }

        this.showed = false;
        this.destroyed = true;

        if (typeof this.params.events.onAfterDestroy ==='function') {
            this.params.events.onAfterDestroy();
        }

        this.params = false;
    }

    getMaxZIndex()
    {
        return Math.max(
            ...Array.from(document.querySelectorAll('body *'), el => {
                    let s = window.getComputedStyle(el);
                    if (s.display === 'none')
                        return 0;
                    return parseFloat(s.zIndex);
                },
            ).filter(zIndex => !Number.isNaN(zIndex)),
            0,
        );
    }

    addEvent(el, eventName, listener)
    {
        if (this.destroyed)
            return;

        el.addEventListener(eventName, listener);

        this.domEvents.push(arguments);
    }

    bindEvents()
    {
        if (this.destroyed)
            return;

        this.addEvent(document, 'keydown', this.documentKeyDown.bind(this));
        this.addEvent(document, 'click', this.documentClick.bind(this));
    }

    setCloseByEsc(value)
    {
        this.params.closeByEsc = !!value;
    }

    setCloseByBackground(value)
    {
        this.params.closeByBackground = !!value;
    }

    documentKeyDown(event)
    {
        if (this.destroyed)
            return;

        if (event.keyCode == 27 && this.params.closeByEsc)
        {
            this.close();
        }

    }

    documentClick(event)
    {
        if (this.destroyed)
            return;

        let isClose = event.target.hasAttribute('data-devbx-popup-close');

        if (!isClose)
        {
            isClose = !!event.target.closest('[data-devbx-popup-close]');
        }

        if (isClose && this.elPopup.contains(event.target))
        {
            this.close();
            return;
        }

        if (this.params.closeByBackground && (event.target === this.elBackground || event.target === this.elContent))
        {
            this.close();
        }
    }

    show()
    {
        if (this.showed || this.destroyed)
            return;

        this.showed = true;

        if (!document.documentElement.style.getPropertyValue('--devbx-scrollbar-compensate'))
        {
            document.documentElement.style.setProperty('--devbx-scrollbar-compensate', (window.innerWidth - document.documentElement.clientWidth)+'px');
        }

        document.documentElement.classList.add('with-devbx-popup');
        document.body.classList.add('devbx-hide-scrollbar');

        this.bindEvents();

        let zIndex = this.params.zIndex || this.getMaxZIndex();

        if (isNaN(zIndex) || zIndex<0)
            zIndex = 0;

        this.elPopup.style.zIndex = zIndex+1000;

        document.body.appendChild(this.elPopup);
    }

    close()
    {
        if (this.showed)
        {
            if (typeof this.params.events.onBeforeClose === 'function' && this.params.events.onBeforeClose() === false)
                return;
        }

        this.destroy();
    }
}

let defaultWebFormParams = {
    autoClose: 3,
};

class WebFormInstance {

    $ajax
    $popup
    $webForm

    constructor(params) {
        this.params = Object.assign({}, defaultWebFormParams, params || {});
    }

    static create(params)
    {
        let instance = new WebFormInstance(params);

        instance.show();

        return instance;
    }

    static setDefaultPopupParams(params)
    {
        defaultPopupParams = Object.assign({}, defaultPopupParams, params || {});
    }

    static getDefaultPopupParams()
    {
        return Object.assign({}, defaultPopupParams);
    }

    prepareContainer()
    {
        if (this.$el)
            return;

        if (this.params.target)
        {
            if (typeof this.params.target === 'string')
            {
                this.$el = document.querySelector(this.params.target);

                if (!this.$el)
                {
                    console.error('invalid selector "'+this.params.target+'"');
                    return false;
                }
            } else {
                this.$el = this.params.target;
            }
        } else {
            let popupParams = {
                events: {
                    onDestroy: this.onPopupDestroy.bind(this)
                }
            };

            this.$popup = new Popup(Object.assign({}, this.params.popup || {}, popupParams));
            this.$popup.show();

            this.$el = this.$popup.elContent;
        }

        if (!(this.$el instanceof Element))
        {
            console.error('invalid WebForm container',this.$el);
            return false;
        }

        return this;
    }

    show()
    {
        if (this.prepareContainer() === false || this.$ajax || this.$webForm)
            return;

        this.$ajax = BX.ajax.runAction('devbx:forms.api.webform.loadForm', {
            data: {
                lang: BX.message('LANGUAGE_ID'),
                siteId: BX.message('SITE_ID'),
                id: this.params.id,
                popup: this.$popup ? 1 : 0,
                inputFields: !!this.params.inputFields ? this.params.inputFields : [],
            }
        }).then(
            this.loadFormSuccess.bind(this),
            this.ajaxError.bind(this)
        );

        return this;
    }

    setWebForm(instance)
    {
        this.$webForm = instance;

        if (this.$popup)
        {
            this.$popup.addEvent(this.$webForm.$el, 'click', (event) => {
                if (this.$popup.params.closeByBackground && event.target.classList.contains('devbx-webform'))
                {
                    this.$popup.close();
                }
            });

            this.$webForm.triggerEvent('popupShow');

            setTimeout(() => {
                this.$webForm.setFocusFirstInput();
            }, 100)


        } else {
            this.$webForm.triggerEvent('formShow');
        }

        BX.addCustomEvent(this.$webForm, 'submitFormSuccess', this.onSubmitFormSuccess.bind(this));
    }

    onSubmitFormSuccess()
    {
        if (this.$popup && this.params.autoClose>0)
        {
            setTimeout(function() {

                if (this.$popup)
                    this.$popup.close();

            }.bind(this), Math.floor(this.params.autoClose*1000));
        }
    }

    onPopupDestroy()
    {
        if (this.$webForm) {
            this.$webForm.triggerEvent('popupDestroy');
            this.$webForm.$.appContext.app.unmount();
            this.$webForm = false;
        }

        this.$popup = false;
        this.$el = false;
    }

    loadFormSuccess(response)
    {
        this.$ajax = false;

        let ob = BX.processHTML(response.data.content + response.data.css + response.data.js);

        if (!this.$el)
        {
            console.error('$el not initialized');
            return;
        }

        this.$el.innerHTML = ob.HTML;

        if (ob.STYLE.length > 0)
            BX.loadCSS(ob.STYLE);

        BX.ajax.processScripts(ob.SCRIPT, true, () => {
            BX.ajax.processScripts(ob.SCRIPT, false, () => {
                BX.onCustomEvent('onDevBxWebFormInitInstance', [this.$el, this]);
            });
        });
    }

    ajaxError(response)
    {
        this.$ajax = false;

        let elErrors = document.createElement('DIV');
        elErrors.className = 'devbx-webform-system-error-container';

        response.errors.forEach(error => {

            let elError = document.createElement('DIV');
            elError.className = 'devbx-webform-system-error';
            elError.innerText = error.message;

            elErrors.appendChild(elError);
        });

        this.$el.appendChild(elErrors)
    }
}

class Manager {
    constructor() {
        document.addEventListener('click', this.documentClick.bind(this));

        (new MutationObserver(this.onMutation.bind(this))).observe(document, {subtree: true, childList: true});

        this.checkWebFormInline(document.querySelectorAll('body *'));
    }

    onMutation(mutationsList)
    {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                this.checkWebFormInline(mutation.addedNodes);
            }
        }
    }

    checkWebFormInline(items)
    {
        items.forEach(el => {
            if (!(el instanceof Element))
                return;

            let elInline = [];

            if (el.hasAttribute('data-devbx-webform-inline'))
            {
                elInline.push(el);
            }

            elInline.push(...el.querySelectorAll('[data-devbx-webform-inline]'));

            elInline.forEach(item => {

                let params = this.getParamsFromNode(item);
                params.id = item.dataset.devbxWebformInline;
                params.target = item;

                item.removeAttribute('data-devbx-webform-inline');

                WebFormInstance.create(params);
            });
        });
    }

    getParamsFromNode(el)
    {
        let params = {
            id: el.dataset.devbxWebform,
            inputFields: {},
        }

        if (el.dataset.target)
        {
            params.target = el.dataset.target;
        }

        for (let [key, value] of Object.entries(el.dataset)) {
            if (key === 'inputfields')
            {
                try {
                    params.inputFields = Object.assign(params.inputFields, JSON.parse(value));
                } catch (e)
                {

                }
            } else
            if (key.startsWith('inputfield'))
            {
                key = key.substring('inputfield'.length);

                let ar = key.match(/(.+)\[(.+)\]/);

                if (ar)
                {
                    if (!params.inputFields[ar[1]])
                    {
                        params.inputFields[ar[1]] = {}
                    }

                    params.inputFields[ar[1]][ar[2]] = value;
                } else {
                    params.inputFields[key] = value;
                }
            }
        }

        return params;
    }

    documentClick(event)
    {
        let elWebForm;

        if (event.target.hasAttribute('data-devbx-webform'))
        {
            elWebForm = event.target;
        }

        if (!elWebForm)
        {
            elWebForm = event.target.closest('[data-devbx-webform]');
        }

        if (!elWebForm)
            return;

        event.preventDefault();

        WebFormInstance.create(this.getParamsFromNode(elWebForm));
    }
}

let manager = new Manager();


export {WebFormInstance};

